'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ColorPicker", {
    enumerable: true,
    get: function() {
        return ColorPicker;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useColorPicker = require("./useColorPicker");
const _renderColorPicker = require("./renderColorPicker");
const _useColorPickerStylesstyles = require("./useColorPickerStyles.styles");
const _colorPicker = require("../../contexts/colorPicker");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const ColorPicker = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useColorPicker.useColorPicker_unstable)(props, ref);
    const contextValues = (0, _colorPicker.useColorPickerContextValues)(state);
    (0, _useColorPickerStylesstyles.useColorPickerStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useColorPickerStyles_unstable')(state);
    return (0, _renderColorPicker.renderColorPicker_unstable)(state, contextValues);
});
ColorPicker.displayName = 'ColorPicker';
